// src/components/CopyrightFooter.js
import React from "react";
import { Link } from "react-router-dom";

import { track } from "../utils/analytics";
import "../styles/CopyrightFooter.css";

import instagramIcon from "../assets/instagram.png";
import twitterIcon   from "../assets/twitter.png";
import facebookIcon  from "../assets/facebook.png";
import youtubeIcon from "../assets/youtube.png";
import Logo          from "../assets/Climformatics-logo.png";

export default function CopyrightFooter({ className = "" }) {
  /* ───────── helper wrappers ───────── */

  const trackSocial = (platform, url) =>
    track("social_click", { location: "footer", platform, url });

  const trackMailto = (email) =>
    track("mailto_click", { location: "footer", email });

  const trackNav = (label, destination) =>
    track("navigation_click", { location: "footer", nav_item: label, destination });

  /* ───────── render ───────── */

  return (
    <footer className={`footer-container ${className}`}>
      <div className="footer-inner">

        {/* ——— LEFT COLUMN ——— */}
        <div className="footer-brand-block">
          <a
            href="https://climformatics.com"
            target="_blank"
            rel="noopener noreferrer"
            className="powered-by"
            onClick={() => trackNav("Powered by Climformatics", "https://climformatics.com")}
          >
            <span>Powered by</span>
            <img src={Logo} alt="Climformatics" />
          </a>
          <span className="footer-copy">© 2025 BestDay2Marry</span>
        </div>

        {/* ——— CENTRE COLUMN ——— */}
        <div className="footer-contact-block">
          <h3>Contact&nbsp;Us</h3>
          <p>
            5381 Ridgewood Drive<br />
            Fremont, CA 94555
          </p>
          <p>Phone: 650-714-3894</p>
          <a
            href="mailto:info@bestday2marry.com"
            onClick={() => trackMailto("info@bestday2marry.com")}
          >
            info@bestday2marry.com
          </a>
        </div>

        {/* ——— RIGHT COLUMN ——— */}
        <div className="footer-right-block">
          <div className="social-icons">
            <a
              href="https://www.instagram.com/bestday2marry"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackSocial("instagram", "https://www.instagram.com/bestday2marry")}
            >
              <img src={instagramIcon} alt="Instagram" />
            </a>
            <a
              href="https://twitter.com/bestday2marry"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackSocial("twitter", "https://twitter.com/bestday2marry")}
            >
              <img src={twitterIcon} alt="Twitter / X" />
            </a>
            <a
              href="https://www.facebook.com/story.php?story_fbid=122111475044104281&id=61553128439124"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                trackSocial("facebook",
                  "https://www.facebook.com/story.php?story_fbid=122111475044104281&id=61553128439124"
                )
              }
            >
              <img src={facebookIcon} alt="Facebook" />
            </a>
            <a
              href="https://www.youtube.com/@BestDay2Marry"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                trackSocial("youtube",
                  "https://www.youtube.com/@BestDay2Marry"
                )
              }
            >
              <img src={youtubeIcon} alt="Youtube" />
            </a>
          </div>

          {/* internal route keeps original styling via Link */}
          <Link
            to="/terms"
            className="footer-link"
            onClick={() => trackNav("Terms", "/terms")}
          >
            Terms of Use &amp; Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}